<template>
  <div class="price-list">
    <div class="price-list-card">
      <div class="level" style="font-weight: bold;">会员级别</div>
      <div class="equity-price">
        <div class="equity-price-item">
          <div class="equity" style="text-align: center;">权益内容</div>
          <div class="price" style="text-align: center;font-weight: bold;">计价</div>
        </div>
      </div>
    </div>
    <div v-for="item in arr" class="price-list-card">
      <div class="level">
        <h3>{{ item.level }}</h3>
      </div>
      <div class="equity-price">
        <div v-for="i in item.contents" class="equity-price-item">
          <div class="equity">{{ i.countent }}</div>
          <div class="price">{{ i.bonus_points }}</div>
        </div>
      </div>
    </div>
    <div class="price-list-card explain">
      <div>注意：</div>
      <div>说明：</div>
    </div>
  </div>
</template>

<script setup>

let arr = [
  {
    "level": "普通会员",
    "contents": [
      {
        "countent": "数字人形象使用权（通用款）",
        "bonus_points": "-"
      },
      {
        "countent": "数字人音色使用权（通用款）",
        "bonus_points": "-"
      },
      {
        "countent": "生成数字人视频（通用款）",
        "bonus_points": "400积分/分钟"
      },
      {
        "countent": "生成数字人音频（标准复刻）",
        "bonus_points": "10积分/分钟"
      },
      {
        "countent": "赠送积分",
        "bonus_points": "2500"
      }
    ]
  },
  {
    "level": "VIP会员",
    "contents": [
      {
        "countent": "数字人形象使用权（通用款/专属款）",
        "bonus_points": "-"
      },
      {
        "countent": "数字人音色使用权（通用款/专属款）",
        "bonus_points": "-"
      },
      {
        "countent": "生成数字人视频（通用款/专属款）",
        "bonus_points": "400积分/分钟"
      },
      {
        "countent": "生成数字人音频（标准复刻/极速复刻）",
        "bonus_points": "10积分/分钟"
      },
      {
        "countent": "AI自动剪辑",
        "bonus_points": "600积分/分钟"
      },
      {
        "countent": "赠送积分",
        "bonus_points": "6000"
      }
    ]
  },
  {
    "level": "SVIP",
    "contents": [
      {
        "countent": "数字人形象使用权（通用款/专属款/精品款）",
        "bonus_points": "-"
      },
      {
        "countent": "数字人音色使用权（通用款/专属款/精品款）",
        "bonus_points": "-"
      },
      {
        "countent": "生成数字人视频（通用款/专属款）",
        "bonus_points": "400积分/分钟"
      },
      {
        "countent": "生成数字人视频（精品款）",
        "bonus_points": "500积分/分钟"
      },
      {
        "countent": "生成数字人音频（标准复刻/极迅复刻）",
        "bonus_points": "10积分/分钟"
      },
      {
        "countent": "生成数字人音频（多语种-标准版）",
        "bonus_points": "60积分/分钟"
      },
      {
        "countent": "生成数字人音频（多语种-高级版）",
        "bonus_points": "450积分/分钟"
      },
      {
        "countent": "AI自动剪辑",
        "bonus_points": "600积分/分钟"
      },
      {
        "countent": "赠送积分",
        "bonus_points": "6000"
      }
    ]
  }
]
</script>

<style lang="scss" scoped>
.price-list {
  border: 4px solid #B3B3B3;
  border-radius: 16px;
  background-image: linear-gradient(to right, #E6F0FF, #CFD3DC);
  padding: 20px;
  color: #333;
  box-sizing: border-box;

  .price-list-card {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px 0px;
    box-sizing: border-box;

    .level {
      width: 250px;
      text-align: center;
    }

    .equity-price {
      flex: 1;

      .equity-price-item {
        display: flex;
        margin: 10px 0px;

        .equity,
        .price {
          flex: 1;
        }

        .equity {
          font-weight: bold;
          flex: 1.5;
        }
      }
    }
  }

  .price-list-card:not(:last-child) {
    border-bottom: 1px solid #ccc;
    /* 你可以根据需要调整边框颜色和宽度 */
  }

  .explain {
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
  }
}
</style>